import * as ACTION from "./UpdateMasterHotelActionType";

const updateMasterHotelSuccess = () => {
  return {
    type: ACTION.UPDATE_MASTER_HOTEL,
    payload: "",
  };
};

export const updateMasterHotelActions = () => {
  return async function (dispatch) {
  dispatch(updateMasterHotelSuccess());
  }
};
